import { Box } from '@chakra-ui/react'

import { RichTextField } from '../../../../components/RichTextField'
import { IContestFormTabProps } from './types'

export function RulesTab({ form, setForm, errors, saving }: IContestFormTabProps) {
  return (
    <Box>
      <RichTextField
        label="Regulamento do concurso"
        error={errors.contest_rules}
        toolbar="full"
        minH="300px"
        value={form.contest_rules}
        onChange={(contest_rules) => setForm((prev) => ({ ...prev, contest_rules }))}
        placeholder="Escreva o regulamento do concurso aqui..."
        isReadOnly={saving}
      />
    </Box>
  )
}
